export class UserSecretQuestionInfo {
    userId: string;
    secretQuestion1Id: number;
    answer1: string;
    secretQuestion2Id: number;
    answer2: string;
    secretQuestion3Id: number;
    answer3: string;
}


// WEBPACK FOOTER //
// ./src/app/models/userSecretQuestionInfo.ts